import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class AppParameters {
    loginUrl = `/api/user/authenticate`;
}
